import {
    computerMenuText,
    cloudLocationsMenuText,
    uploadAndShareFromCloudMenuText,
    uploadAndShareFromCloudMenuTooltip,
} from 'owa-attachment-filepicker/lib/index.locstring.json';
import loc from 'owa-localize';
import getCreateAttachmentHandlerForLocalFile from './getCreateAttachmentHandlerForLocalFile';
import { getCreateAttachmentHandlerForUpsell } from './getCreateAttachmentHandlerForUpsell';
import type AttachmentMultiMenuEntry from '../types/AttachmentMultiMenuEntry';
import { logUsage } from 'owa-analytics';
import type { CreateAttachmentHandlerParams } from 'owa-attachment-filepicker';
import type { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { ControlIcons } from 'owa-control-icons';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import getAttachmentPolicy from 'owa-session-store/lib/utils/getAttachmentPolicy';
import { isDataProviderAvailable } from 'owa-fileprovider-store/lib/utils/isDataProviderAvailable';

import styles from '../components/AttachmentMultiMenuEntryIcons.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

const attachmentMultiMenuEntry: AttachmentMultiMenuEntry = {
    computer: {
        isEnabled: (isGroupsScenario?: boolean) => true,
        text: () => loc(computerMenuText),
        iconProps: {
            iconName: ControlIcons.System,
            styles: {
                root: classNames(styles.iconRoot, styles.iconRootComputer),
            },
        },
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (36,9): Type '(viewState: AttachmentWellViewState, createAttachment: CreateAttachmentsFunc, composeUniqueState: ComposeUniqueState, targetWindow: Window, insertLinkHandler: InsertLinkHandler | null, treatShareAsInsertLink?: boolean | undefined) => CreateAttachmentHandler' is not assignable to type 'GetCreateAttachmentHandlerFunc'.
        // @ts-expect-error
        getCreateAttachmentHandler: getCreateAttachmentHandlerForLocalFile,
        logUsage: (entrySource: { toString: () => string }, suggestedAttachmentTraceId: string) => {
            logUsage(
                'FPDualEntryComputer',
                { entrySource: entrySource.toString(), suggestedAttachmentTraceId },
                { isCore: true, excludeFromKusto: true }
            );
        },
    },
    onlineLocation: {
        isEnabled: (isGroupsScenario?: boolean) => true,
        text: () => loc(cloudLocationsMenuText),
        iconProps: {
            iconName: ControlIcons.Cloud,
            styles: {
                root: classNames(styles.iconRoot, styles.iconRootCloud),
            },
        },
        getCreateAttachmentHandler: (_, createAttachment) => {
            return (createAttachmentHandlerParams: CreateAttachmentHandlerParams) => {
                const baseProperties = {
                    isInline: createAttachmentHandlerParams.isInline,
                    isHiddenInline: false,
                };
                const properties: CreateAttachmentsProperties = createAttachmentHandlerParams.shouldShare
                    ? { ...baseProperties, shouldShare: true }
                    : { ...baseProperties, shouldShare: false };

                createAttachment(
                    createAttachmentHandlerParams.files,
                    properties,
                    createAttachmentHandlerParams.dataProviderType
                );
            };
        },
        logUsage: (entrySource: { toString: () => string }, suggestedAttachmentTraceId: string) => {
            logUsage(
                'FPDualEntryFilePicker',
                { entrySource: entrySource.toString(), suggestedAttachmentTraceId },
                { isCore: true, excludeFromKusto: true }
            );
        },
    },
    uploadAndShareFromCloud: {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (83,9): Type '(isGroupsScenario?: boolean | undefined) => boolean | undefined' is not assignable to type '(isGroupsScenario?: boolean | undefined) => boolean'.
        // @ts-expect-error
        isEnabled: (isGroupsScenario?: boolean) => {
            return (
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2345 (88,41): Argument of type 'boolean | undefined' is not assignable to parameter of type 'boolean'.
                // @ts-expect-error
                isDataProviderAvailable(isGroupsScenario) &&
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2532 (92,17): Object is possibly 'undefined'.
                // @ts-expect-error
                getAttachmentPolicy().ReferenceAttachmentsEnabled &&
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2532 (96,18): Object is possibly 'undefined'.
                // @ts-expect-error
                !getUserConfiguration().SessionSettings.IsShadowMailbox
            );
        },
        text: () => loc(uploadAndShareFromCloudMenuText),
        ariaLabel: () => loc(uploadAndShareFromCloudMenuTooltip),
        iconProps: {
            iconName: ControlIcons.CloudUpload,
            styles: {
                root: classNames(styles.iconRoot, styles.iconRootUploadAndShare),
            },
        },
        getCreateAttachmentHandler: getCreateAttachmentHandlerForUpsell,
        logUsage: (entrySource: { toString: () => string }, suggestedAttachmentTraceId: string) => {
            logUsage(
                'FPMultiEntryUploadAndShareFromCloud',
                {
                    entrySource: entrySource.toString(),
                    suggestedAttachmentTraceId,
                },
                { isCore: true, excludeFromKusto: true }
            );
        },
    },
};

export default attachmentMultiMenuEntry;
